import { render, staticRenderFns } from "./ViewToggle.vue?vue&type=template&id=6c183e78&"
import script from "./ViewToggle.vue?vue&type=script&lang=ts&"
export * from "./ViewToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports